module.exports = __webpack_public_path__ + "img/stand_boluo_think_cut.cbaf4395.png";